<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
 
    <div class="row">
      <div class="col-12">
        <filter-manager
          
          v-model="searchModel.filters"
          ref="reportFilterRed"
          :filters="filterManagerConfig"
          @search="this.downloadReport"
          items-container-class="flex-wrap"
          :display-advanced="false"
          class="search-bar"
          search-text="Procesar"
          search-icon="fa fa-sync"
          search-container-class="btn-process"
          :is-advanced="false"
        />
      </div>
      
    </div>
    
  </div>
</template>


<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import CodeApiServices from '@/services/api/code.api'
import reportApi from '@/modules/report/api'
import DocumentsService from '@//modules/report/document'


export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Comentario de Estudiantes',
      routes: ['Informes', 'Comentarios de Estudiantes'],
    },   
    searchModel: {
      collections: {
        academicYears: [],
        commentTypes: [],
      },
      filters: {
        academicYear: null,
        commentType: null,
        sie: null,
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYears',
          component: 'CustomDropDown',
          options: this.searchModel.collections.academicYears,
          value: this.searchModel.filters.academicYear,
          onChanged: this.onChangeAcademicYear,            
          class: 'col-sm-3 col-md-3',
          label: 'Año Académico',
          placeholder: 'Seleccione',
          fieldName: 'description',
          fieldKey: 'id',
        },
        {
          name: 'commentTypes',
          component: 'CustomDropDown',
          options: this.searchModel.collections.commentTypes,
          value: this.searchModel.filters.commentType,
          class: 'col-sm-3 col-md-3',
          label: 'Tipo de Comentario',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
        
        },
        {
          name: 'sie',
          component: 'CustomInput',
          class: 'col-sm-3 col-md-4',
          placeholder: 'Escriba Número de SIE o Número de Registro',
          value: this.searchModel.filters.sie,
          label: 'SIE / Registro',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          type: 'text',
          validations: 'required',
          error: 'El campo SIE / Registro es obligatorio.',
        },
      ]
    },
  },
  async mounted() {
    this.initFilters()
  },
  methods: {
    async initFilters() {
      await CodeApiServices.GetReportCommentsTypeParams()
        .then((res) => {
          this.searchModel = res.data
        })       
    },
    setFilters(data) {
      this.filters.academicYear = data.academicYears
      this.filters.commentTypes = data.commentTypes
    },
    async downloadReport() {
      const isValid = await this.$refs.reportFilterRed.$refs.formValidator.validate()
      if (isValid) {
        reportApi
          .getReport('getStudentComment', {
            AcedemicYearId: this.searchModel.filters.academicYear?.id,
            CommentTypeId: this.searchModel.filters.commentTypes?.id,
            StudentSieId: this.searchModel.filters.sie,
          })
          .then((res) => {
            DocumentsService.Download(res.data)
          })
      }
    },
    onChangeAcademicYear(value) {
     this.searchModel.filters.academicYear = value
    },
  },
}
</script>

<style scoped>
.btn-outline-green {
  border: 1px solid var(--highlight-color-button-default);
  border: 1px solid #2db782;
  border-radius: 4px;
  opacity: 1;
  color: #2db782;
}
</style>